export default __webpack_public_path__ + "static/8-d8af1c696187bfb184e59f7a709240a2.png";